const TASK_BTN_WIDTH = 16;
const GAP = 4;
const MAX_WIDTH = 224;

export const MAX_ITEM_IN_VIEW = Math.floor(MAX_WIDTH / (TASK_BTN_WIDTH + GAP));

const marginPagesDisplayed = 2;
const pageRangeDisplayed = MAX_ITEM_IN_VIEW - marginPagesDisplayed * 2;

const calculateRightLeftSides = (currentTaskIndex: number, tasksLength: number) => {
	let leftSide = pageRangeDisplayed / 2;
	let rightSide = pageRangeDisplayed - leftSide;

	// If the selected page index is on the default right side of the pagination,
	// we consider that the new right side is made up of it (= only one break element).
	// If the selected page index is on the default left side of the pagination,
	// we consider that the new left side is made up of it (= only one break element).
	if (currentTaskIndex > tasksLength - leftSide) {
		rightSide = tasksLength - currentTaskIndex;
		leftSide = pageRangeDisplayed - rightSide;
	} else if (currentTaskIndex < leftSide) {
		leftSide = currentTaskIndex;
		rightSide = pageRangeDisplayed - leftSide;
	}

	leftSide = Math.floor(leftSide);
	rightSide = Math.floor(rightSide);

	return { leftSide, rightSide };
};

const getPaginationItems = (
	currentTaskIndex: number,
	tasksLength: number
): { type: 'page' | 'break'; index: number }[] => {
	const { leftSide, rightSide } = calculateRightLeftSides(currentTaskIndex, tasksLength);

	// process the pages or breaks to display (or not).
	const pagesBreaking: { type: 'page' | 'break'; index: number }[] = [];

	for (let index = 0; index < tasksLength; index++) {
		const page = index + 1;

		// If the page index is lower than the margin defined,
		// the page has to be displayed on the left side of
		// the pagination.
		if (page <= marginPagesDisplayed) {
			pagesBreaking.push({
				type: 'page',
				index
			});
			continue;
		}

		// If the page index is greater than the page count
		// minus the margin defined, the page has to be
		// displayed on the right side of the pagination.
		if (page > tasksLength - marginPagesDisplayed) {
			pagesBreaking.push({
				type: 'page',
				index
			});
			continue;
		}

		// If it is the first element of the array the rightSide need to be adjusted,
		//  otherwise an extra element will be rendered
		const adjustedRightSide = currentTaskIndex === 0 && pageRangeDisplayed > 1 ? rightSide - 1 : rightSide;

		// If the page index is near the currentTaskIndex page index
		// and inside the defined range (pageRangeDisplayed)
		// we have to display it (it will create the center
		// part of the pagination).
		if (index > currentTaskIndex - leftSide && index < currentTaskIndex + adjustedRightSide) {
			// making sure the break is one index before the pagination group
			if (pagesBreaking[pagesBreaking.length - 1]?.type === 'break') {
				pagesBreaking[pagesBreaking.length - 1].index = index - 1;
			}
			pagesBreaking.push({
				type: 'page',
				index
			});

			continue;
		}

		// If the page index doesn't meet any of the conditions above,
		// we check if the last item of the current "items" array
		// is a break element. If not, we add a break element, else,
		// we do nothing (because we don't want to display the page).
		if (
			pagesBreaking.length > 0 &&
			pagesBreaking[pagesBreaking.length - 1].type !== 'break' &&
			// We do not show break if only one active page is displayed.
			(pageRangeDisplayed > 0 || marginPagesDisplayed > 0)
		) {
			pagesBreaking.push({ type: 'break', index });
		}
	}

	return pagesBreaking;
};

export const taskTooltipFooterProvider = {
	getPaginationItems
};
